module.exports = __webpack_public_path__ + "img/import.f1da4d5b.svg";